import * as React from 'react';
import {CheckCircle} from "lucide-react";

const PriceCardContents: React.FC<{
  price: number;
  planName: string;
  features: string[];
}> = ({
  price,
  planName,
  features
}) => {
  return (
    <div className="flex w-full flex-col mb-5">
      <p className="text-center font-bold text-5xl">${price}</p>
      <p className="text-center text-xl mt-2">{planName}</p>
      <div className="flex flex-col gap-5 mt-7">
        {features.map((feature, i) => (
          <div key={"feature-" + i} className="flex flex-row gap-3">
            <CheckCircle color="#0F9D58" />
            <p className="text-xl">{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PriceCardContents;
